import { cn } from '@/lib/utils'

/**
 * A spinner is a message about WORK: something the person started is under way. It is not a
 * loading state for content — that is a skeleton, which promises the shape about to arrive — and
 * never an answer to a failure (CLAUDE.md, "A failed fetch is a rendered state").
 *
 * A thin ring with one arc, drawn in `currentColor` so it takes the colour of whatever it sits in:
 * on a primary button it is primary-foreground, in muted text it is muted. Sized like a lucide
 * icon (`size-4`) so it can stand in for one. With a `label` it announces itself as a status;
 * without one it is decoration, for when the text beside it already says what is happening —
 * which is how `<Button pending>` uses it.
 */
function Spinner({ className, label, ...props }: React.SVGProps<SVGSVGElement> & { label?: string }) {
    return (
        <svg
            data-slot="spinner"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            strokeLinecap="round"
            className={cn('size-4 shrink-0 animate-spin', className)}
            {...(label ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true })}
            {...props}
        >
            <circle cx="12" cy="12" r="9.5" className="opacity-20" />
            <path d="M21.5 12a9.5 9.5 0 0 0-9.5-9.5" />
        </svg>
    )
}

export { Spinner }
